// How long a toast stays up when the caller does not say.
//
// Three seconds is right for "Saved" and wrong for a failure. An API error here is
// frequently a provider's raw JSON -- OpenRouter's 402 runs to about 600 characters
// and names the remedy at the very end -- and three seconds is not enough to read
// that, let alone copy it or capture it. It was reported on 2026-09-07 as
// "the error needs to stay up longer, I can barely screenshot it".
//
// Errors are not made sticky, because a toast with no timer and no confirm button
// can only be dismissed by clicking it, and one left open covers the next one. Thirty
// seconds is long enough to read and screenshot while still clearing itself.
//
// Two escapes already exist and both still work: hovering pauses the countdown
// (mouseenter -> stopTimer, below), and clicking dismisses immediately.
const NOTIFY_TIMER_DEFAULT = 3000;
const NOTIFY_TIMER_ERROR = 30000;

export function notify( type, message, timer ) {
	const str = typeof message === `object` ? message.toString() : message;

	const default_timer = type === `error` ? NOTIFY_TIMER_ERROR : NOTIFY_TIMER_DEFAULT;

	import( `sweetalert2/src/sweetalert2.js` ).then(
		( { default: Swal } ) => {
			Swal.fire( {
				toast: true,
				position: `top-end`,
				showConfirmButton: false,
				timer: typeof timer === `number` ? timer : default_timer,
				timerProgressBar: true,
				icon: type,
				html: str.replace( /(?:\r\n|\r|\n)/g, `<br>` ),
				didOpen: toast => {
					toast.addEventListener( `mouseenter`, Swal.stopTimer );
					toast.addEventListener( `mouseleave`, Swal.resumeTimer );
					toast.addEventListener( `click`, () => Swal.close() );
				}
			} );
		}
	);
}

export function confirm( message ) {
	const str = typeof message === `object` ? message.toString() : message;

	return import( `sweetalert2/src/sweetalert2.js` ).then(
		( { default: Swal } ) => Swal.fire( {
			showCancelButton: true,
			icon: `warning`,
			text: str
			// iconColor: icon_color,
		} )
	);
}

export function confirm_archive( label ) {
	return confirm( `Are you sure you want to archive this ${label}?` );
}
